export default "__VITE_ASSET__CljV1ueA__"